export const environment = {
    prod: false,
    authUrl: 'https://apipruebasexternas.dian.gov.co/identidad/sts/v1/tokens/login',
    searchUrl: 'https://apipruebasazure.dian.gov.co/exogena/api/v1/terceros/declaracion',
    componentPreguntas : 'https://piatest.dian.gov.co/preguntaseguridad',
    tipoDocumento: 'US',
    nit: '800197268',
    key: 'C82CDB4A4E1B0F63',
    pass: 'O8Ewn3eIGnpuLTWhQbE5XGSIHCVeK1**',
    clientId: 'WIg6h8OKt1aMMdgqSvmjMCuXDl8a',
    clientSecret: 'K9EcqAHYfRVaTM5pZLsirk1fQJIa',
    nroDocumento: 70053,
    captchaPublic: '0x4AAAAAAAg1VyVQowrc7tRR',
    tituloBusqueda: 'Consulta Renta ',
    tituloResultados: 'Resultados Consulta Renta ',
    contactoErrorLinkLabel: 'Registraduría Nacional del estado colombiano',
    contactoErrorLink: 'https://www.registraduria.gov.co/',
    retryAfter401: 2,
    tokenAPI: 'https://apipruebasexternas.dian.gov.co/identidad/sts/v1/tokens/micrositio',
    enlaces: {
        backLink: 'https://micrositios.dian.gov.co/renta-personas-naturales-ag-2025/',
        notificacionesJudiciales: 'https://www.dian.gov.co/Paginas/Notificaciones-Judiciales-Formulario.aspx',
        mapaDelSitio: 'https://www.dian.gov.co/Paginas/MapaDelSitio.aspx',
        pqsr: 'https://www.dian.gov.co/atencionciudadano/PQSRD/Paginas/Inicio.aspx',
        puntosDeContacto: 'https://www.dian.gov.co/atencionciudadano/contactenos/Paginas/PuntosContacto.aspx',
        politicaSeguridadInformacion: 'https://www.dian.gov.co/Documents/POLITICA_GENERAL_DE_SEGURIDAD_Y_PRIVACIDAD_DE_LA_INFORMACION.pdf',
        politicaPrivacidadYTerminos: 'https://www.dian.gov.co/Paginas/Privacidad.aspx',
        politicaDatosPersonales: 'https://www.dian.gov.co/normatividad/Normatividad/Circular-000001-de-25-01-2019.pdf',
        co: 'https://www.colombia.co/',
        govCo: 'https://www.gov.co/',
        calendarioTributario: 'https://www.dian.gov.co/Paginas/CalendarioTributario.aspx',
        inquietudesRenta: 'https://micrositios.dian.gov.co/renta-personas-naturales-ag-2025/',
        conozcaMasRut: 'https://muisca.dian.gov.co/WebRutVirtualInscripcion/#/proceso-guiado/tipoPersona',
        dian: 'https://www.dian.gov.co/',
        sociales: {
            x: 'https://twitter.com/DIANColombia',
            youtube: 'https://www.youtube.com/channel/UCkaPJ8afIoa_RDKEHaQIxrw',
            linkedin: 'https://www.linkedin.com/company/diancolombia/',
            facebook: 'https://www.facebook.com/DIANCol/',
            instagram: 'https://www.instagram.com/diancolombia/?hl=es-la',
            tiktok: 'https://www.tiktok.com/@diancolombia',
        }
    }
};
